import CheckmateApiClient from '../../../services/apiClient';
import { HttpResponseError } from '../../../interfaces/IHttpResponseError';
import { ICaseResolutionModel } from '../../../interfaces/ICaseResolutionModel';
import { useMutation } from 'react-query';

const _apiClient = new CheckmateApiClient();

export const useSetCaseUnpinned = () => {
    return useMutation({
        mutationFn: async (caseModel: ICaseResolutionModel | undefined) => {
            if (!caseModel) throw new Error('Failed to case update');

            const response = await _apiClient.setCaseResolutionUnpinned(
                caseModel.id
            );

            if (response?.httpResponse.status === 401) {
                window.location.reload();
            }

            if (!response?.httpResponse.ok) {
                const error: HttpResponseError = new Error(
                    'Failed to update case'
                );
                error.status = response.httpResponse.status;
                throw error;
            }

            return response.payload;
        },
    });
};